import checkConditions from './check-conditions'
import presentRule from './present-rule'

export default async function (groupRules, eventBus, condition, args) {
    args = args || {}
    var rules = []
    for (const rule of groupRules) {
        if (!condition || condition(rule)) {
            rules.push(rule)
        }
    }

    var checkedRules = await checkConditions(rules, args)
    if (!checkedRules) {
        return
    }

    args = Object.assign(args, window.addiesaas.cart_rules.commonArgs)

    const displays = []

    for (const rule of checkedRules) {
        const display = await presentRule(rule, eventBus, false, args)

        displays.push(display)

        if (rule.is_last) {
            break
        }
    }

    return displays
}
